/* eslint-disable no-useless-constructor */
import moment from "moment";
import * as XLSX from "xlsx";

export class ExcelFileDownload {
  constructor(fileName, data, keys) {
    this.fileName = fileName;
    this.data = data;
    this.keys = keys;
  }
  generatePayoutReports(data) {
    this.data = data;
    this.fileName = "Payout_Report_data.xlsx";
    const collectKeys = [
      "Transaction Date",
      "Pay out Date",
      "Transaction ID",
      "Third Party Reference",
      "Transaction Currency",
      "Transaction Amount",
      "Transaction Type",
      "Beneficiary Name",
    ];
    const sheetData = this.data?.map((i) => {
      const transactionDate = moment(i.transactionDate).format(
        "YYYY-MM-DD h:mm:ss"
      );
      const payOutDate = moment(i.payOutDate).format("YYYY-MM-DD h:mm:ss");
      let payload = new Map();
      payload.set("Transaction Date", transactionDate);
      payload.set("Pay out Date", payOutDate);
      payload.set("Transaction ID", i.transactionID);
      payload.set("Third Party Reference", i.thirdPartyReference);
      payload.set("Transaction Currency", i.transactionCurrency);
      payload.set("Transaction Amount", i.transactionAmount);
      payload.set("Transaction Type", i.transactionType);
      payload.set("Beneficiary Name", i.beneficiaryName);
      const csvObject = Object.fromEntries(payload);
      return csvObject;
    });
    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.utils.sheet_add_aoa(worksheet, [collectKeys], {
      origin: "A1",
    });
    XLSX.writeFile(workbook, this.fileName);
  }

  generateDefaultCsv(data = {}, fileName) {
    this.data = data;
    this.fileName = fileName;
    const jsonData = this.data.dto;
    const collectKeys = this.data.keys.map((i) => {
      return i;
    });
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.utils.sheet_add_aoa(worksheet, [collectKeys], {
      origin: "A1",
    });
    XLSX.writeFile(workbook, this.fileName);
  }
}
